<template>
  <main class="cover-auth">
    <div class="widget-sign-up">
      <form class="s20 form" @submit.prevent="handleSubmit">
        <a href="#">
          <div class="text-center mb-8">
            <img src="/public/images/logo-wide.svg" class="auth-logo2" />
          </div>
        </a>

        <h2 class="font-semibold mt-5 mb-4 text-center">Créer votre compte</h2>

        <div class="s10_mobile container-full-2"> 
          <h2 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
            <img src="/public/icons/icon-info-perso.svg" class="size-l" alt="" /> 
            Informations personnelles
          </h2>
          
          <div class="form-field-floating lg reactive active my-5">
            <input 
              type="text" 
              class="form-input" 
              name="nom" 
              id="nom" 
              v-model="formData.nom"
              placeholder=""
            >
            <label for="nom">Nom <b class="color-danger">*</b></label>
          </div>
          
          <div class="form-field-floating lg reactive my-5">
            <input 
              type="text" 
              class="form-input" 
              name="prenom" 
              id="prenom" 
              v-model="formData.prenom"
              placeholder=""
            >
            <label for="prenom">Prénoms <b class="color-danger">*</b></label>
          </div>

          <div class="form-field-split my-5">
            <div class="form-field-floating lg reactive half">
              <input
                type="date"
                class="form-input"
                name="date_naissance"
                id="date_naissance"
                :value="formData.dateNaissance"
                @input="onDateNaissanceChange"
                @change="onDateNaissanceChange"
                placeholder=""
              >
              <label for="date_naissance">Date de naissance <b class="color-danger">*</b></label>
            </div>
            <hr class="hr" />
            <div class="form-field-floating lg reactive half">
              <input 
                type="text" 
                class="form-input" 
                name="age" 
                id="age" 
                v-model="formData.age"
                readonly
                placeholder=""
              >
              <label for="age">Age <b class="color-danger">*</b></label>
            </div>
          </div>
          
          <div class="form-field-split my-5">
            <div class="form-field-floating lg reactive half">
              <input
                type="date"
                class="form-input"
                name="date_engagement"
                id="date_engagement"
                :value="formData.dateEngagement"
                @input="onDateEngagementChange"
                @change="onDateEngagementChange"
                placeholder=""
              >
              <label for="date_engagement">Date d'engagement <b class="color-danger">*</b></label>
            </div>
            <hr class="hr" />
            <div class="form-field-floating lg reactive half">
              <input 
                type="text" 
                class="form-input" 
                name="anciennete" 
                id="anciennete" 
                v-model="formData.anciennete"
                readonly
                placeholder=""
              >
              <label for="anciennete">Ancienneté <b class="color-danger">*</b></label>
            </div>
          </div>

          <div class="form-field-floating full lg my-5">
            <select 
              class="form-input-select" 
              name="collectivite" 
              id="collectivite"
              v-model="formData.collectivite"
            >
              <option value="">Sélectionnez votre collectivité</option>
              <option 
                v-for="collectivite in collectivites" 
                :key="collectivite.id" 
                :value="collectivite.id"
              >
                {{ collectivite.nom }}
              </option>
            </select>
            <label for="collectivite">Votre collectivité <b class="color-danger">*</b></label>
          </div>
        </div>  

        <div class="s10_mobile container-full-2">
          <div class="h-20 show-mobile"></div>
          <h2 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
            <img src="/public/icons/icon-engagement.svg" class="size-l" alt="" /> 
            Engagement
          </h2>
          
          <div class="form-field-floating xl reactive active my-5">
            <input 
              type="text" 
              class="form-input" 
              name="salaire_brut" 
              id="salaire_brut" 
              v-model="formData.salaireBrut"
              @input="calculateQuotiteCessible"
              placeholder=""
            >
            <label for="salaire_brut">Salaire brut <b class="color-danger">*</b></label>
            <span>F&nbsp;CFA</span>
          </div>
          
          <div class="form-field-split active my-5">
            <div class="form-field-floating xl reactive half">
              <input 
                type="text" 
                class="form-input" 
                name="quotite_cessible" 
                id="quotite_cessible" 
                v-model="formData.quotiteCessible"
                @input="calculateQuotiteCessibleValue"
                placeholder=""
              >
              <label for="quotite_cessible">Quotité cessible max <b class="color-danger">*</b></label>
              <span class="">%</span>
            </div>
            <hr class="hr" />
            <div class="form-field-floating xl reactive half">
              <input 
                type="text" 
                class="form-input" 
                name="quotite_cessible_val" 
                id="quotite_cessible_val" 
                v-model="formData.quotiteCessibleVal"
                readonly
                placeholder=""
              >
              <label for="quotite_cessible_val">Valeur <b class="color-danger">*</b></label>
              <span class="">F&nbsp;CFA</span>
            </div>
          </div>

          <div class="form-field-floating full lg my-5">
            <CustomPhoneInput
              v-model="formData.telephone"
              input-id="telephone"
              label="Numéro de téléphone"
            />
          </div>

          <div class="form-field-floating lg reactive my-5">
            <input
              type="email"
              class="form-input"
              name="email"
              id="email"
              v-model="formData.email"
              placeholder=""
            >
            <label for="email">Adresse Email <b class="color-danger">*</b></label>
          </div>

          <button 
            type="submit" 
            class="btn lg w-100 flex-center mt-8 mb-7"
            :disabled="isSubmitting"
          >
            <img src="/public/icons/icon-valider.svg" class="btn-icon" alt="" />
            <span>{{ isSubmitting ? 'Envoi en cours...' : 'Continuer' }}</span>
          </button>
          
          <router-link to="/signin">
            <h5 class="text-primary-color text-center">Vous avez déjà un compte ?</h5>
          </router-link>
        </div>
      </form>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import authService from '@/services/authService'
import generalService from '@/services/generalService'
import { showAlert } from '@/utils/swal'
import CustomPhoneInput from '@/components/CustomPhoneInput.vue'

interface FormData {
  nom: string
  prenom: string
  dateNaissance: string
  age: string
  dateEngagement: string
  anciennete: string
  collectivite: string
  salaireBrut: string
  quotiteCessible: string
  quotiteCessibleVal: string
  telephone: string
  email: string
}

export default defineComponent({
  name: 'SignUp',
  components: {
    CustomPhoneInput
  },
  setup() {
    const router = useRouter()
    const isSubmitting = ref(false)
    const collectivites = ref<any[]>([])
    const pays = ref<any[]>([])
    const formData = reactive<FormData>({
      nom: '',
      prenom: '',
      dateNaissance: '',
      age: '',
      dateEngagement: '',
      anciennete: '',
      collectivite: '',
      salaireBrut: '',
      quotiteCessible: '',
      quotiteCessibleVal: '',
      telephone: '',
      email: ''
    })

    // Charger les collectivités et pays au montage
    onMounted(async () => {
      try {
        const [collectivitesResponse, paysResponse] = await Promise.all([
          generalService.getCollectivites(),
          generalService.getPays()
        ])

        if (collectivitesResponse.status === 0 && collectivitesResponse.data) {
          collectivites.value = collectivitesResponse.data
        }

        if (paysResponse.status === 0 && paysResponse.data) {
          pays.value = paysResponse.data
        }
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error)
      }
    })

    const calculateAge = () => {
      if (formData.dateNaissance) {
        const birthDate = new Date(formData.dateNaissance)
        const today = new Date()
        let age = today.getFullYear() - birthDate.getFullYear()
        const monthDiff = today.getMonth() - birthDate.getMonth()

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }

        formData.age = age.toString() + ' ans'
      }
    }

    const onDateNaissanceChange = (e: Event) => {
      formData.dateNaissance = (e.target as HTMLInputElement).value
      calculateAge()
    }

    const onDateEngagementChange = (e: Event) => {
      formData.dateEngagement = (e.target as HTMLInputElement).value
      calculateAnciennete()
    }

    const calculateAnciennete = () => {
      if (formData.dateEngagement) {
        const engagementDate = new Date(formData.dateEngagement)
        const today = new Date()
        let years = today.getFullYear() - engagementDate.getFullYear()
        let months = today.getMonth() - engagementDate.getMonth()
        
        if (months < 0) {
          years--
          months += 12
        }
        
        if (years > 0) {
          formData.anciennete = `${years} an${years > 1 ? 's' : ''}`
          if (months > 0) {
            formData.anciennete += ` et ${months} mois`
          }
        } else {
          formData.anciennete = `${months} mois`
        }
      }
    }

    const calculateQuotiteCessible = () => {
      if (formData.salaireBrut && formData.quotiteCessible) {
        calculateQuotiteCessibleValue()
      }
    }

    const calculateQuotiteCessibleValue = () => {
      if (formData.salaireBrut && formData.quotiteCessible) {
        const salaire = parseFloat(formData.salaireBrut.replace(/\s/g, ''))
        const quotite = parseFloat(formData.quotiteCessible)
        
        if (!isNaN(salaire) && !isNaN(quotite)) {
          const value = (salaire * quotite) / 100
          formData.quotiteCessibleVal = Math.round(value).toString()
        }
      }
    }

    const handleSubmit = async (event: Event) => {
      console.log('handleSubmit called')
      
      // Empêcher la soumission par défaut du formulaire
      if (event) {
        event.preventDefault()
      }

      // Validation
      if (!formData.nom || !formData.prenom || !formData.dateNaissance || 
          !formData.dateEngagement || !formData.salaireBrut ||
          !formData.quotiteCessible || !formData.telephone || !formData.email) {
        await showAlert.warning('Veuillez remplir tous les champs obligatoires')
        return
      }

      if (!formData.collectivite) {
        await showAlert.warning('Veuillez sélectionner votre collectivité')
        return
      }

      isSubmitting.value = true
      console.log('Submitting form...')

      try {
        // Préparer les données pour l'API
        const registerData = {
          nom: formData.nom,
          prenom: formData.prenom,
          telephone: formData.telephone.replace(/\s/g, ''),
          email: formData.email,
          salaire: parseFloat(formData.salaireBrut.replace(/\s/g, '')),
          quotiteCessiblePourcent: parseFloat(formData.quotiteCessible),
          quotiteCessibleMontant: parseFloat(formData.quotiteCessibleVal.replace(/\s/g, '')),
          paysId: 1, // Par défaut Côte d'Ivoire
          collectiviteId: parseInt(formData.collectivite),
          dateNaissance: formData.dateNaissance,
          dateEngagement: formData.dateEngagement
        }

        // Appel à l'API d'inscription
        console.log('Calling register API with data:', registerData)
        const response = await authService.register(registerData)
        console.log('Register response:', response)

        if (response.status === 0) {
          // Succès - L'email avec le code OTP a été envoyé
          // Stocker temporairement les données pour les afficher sur la page d'activation
          sessionStorage.setItem('registerData', JSON.stringify({
            nom: formData.nom,
            prenom: formData.prenom,
            email: formData.email,
            telephone: formData.telephone,
            collectivite: collectivites.value.find(c => c.id === parseInt(formData.collectivite))?.nom || 'Non définie'
          }))

          await showAlert.success('Inscription réussie ! Un email avec un code de vérification vous a été envoyé.')
          
          // Rediriger vers la page de saisie du code OTP
          router.push('/auth/otp')
        } else {
          // Erreur
          await showAlert.error(response.message || 'Erreur lors de l\'inscription')
        }
      } catch (error) {
        console.error('Erreur lors de l\'inscription:', error)
        await showAlert.error('Une erreur est survenue. Veuillez réessayer.')
      } finally {
        isSubmitting.value = false
      }
    }

    return {
      formData,
      collectivites,
      pays,
      isSubmitting,
      calculateAge,
      calculateAnciennete,
      onDateNaissanceChange,
      onDateEngagementChange,
      calculateQuotiteCessible,
      calculateQuotiteCessibleValue,
      handleSubmit
    }
  }
})
</script>
